import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// @TODO: Make clear what we need about agent data
export interface Agent {
  aud: string
  familyName: string
  givenName: string
  scope: string
  sub: string
}

interface AuthenticatedData {
  agent: Agent
  isAuthenticated: boolean
}
export interface AuthReducerState {
  isAuthenticated: boolean
  error?: Error
  agent: Agent
  loading: boolean
}

export const initialStateAuth: AuthReducerState = {
  isAuthenticated: false,
  agent: {
    aud: '',
    familyName: '',
    givenName: '',
    scope: '',
    sub: '',
  },
  error: undefined,
  loading: true,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialStateAuth,
  reducers: {
    // We need to control loading so AuthenticatedRoute does not kick us before validation finished
    authInit(_state) {
      return { ...initialStateAuth, loading: true }
    },
    setAuthenticationData(_state, action: PayloadAction<AuthenticatedData>) {
      return { ...initialStateAuth, ...action.payload, loading: false }
    },
  },
})

export const { authInit, setAuthenticationData } = authSlice.actions

const authReducer = authSlice.reducer

export default authReducer
